import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { RadioOption } from './RadioOption';
/**
 * Use RadioOption instead.
 *
 * This exists for backwards compatibility only.
 *
 * @deprecated
 */

export var RadioInline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(RadioOption, _extends({
    ref: ref
  }, props, {
    inline: true
  }));
});
RadioInline.displayName = 'RadioInline';